/* documentation: https://developers.customerfields.com/front-end-api/js-events/ */
/**
 * Version 2.3 added further features to better integrate with lawn size calculator.
 *
 */
(function () {

  var cfForm = false;

  const hardinessZoneMap = [null, null, null,
    {
      zone: 3,
      region: 1,
      period: 'April to October'
    },
    {
      zone: 4,
      region: 1,
      period: 'April to October'
    },
    {
      zone: 5,
      region: 1,
      period: 'April to October'
    },
    {
      zone: 6,
      region: 1,
      period: 'April to October'
    },
    {
      zone: 7,
      region: 2,
      period: 'April to November'
    },
    {
      zone: 8,
      region: 2,
      period: 'April to November'
    },
    {
      zone: 9,
      region: 3,
      period: 'February to November'
    },
    {
      zone: 10,
      region: 3,
      period: 'February to November'
    },
    {
      zone: 11,
      region: 3,
      period: 'February to November'
    },
  ]

  const lawnSizeOptions = [
    '<small>under 3000 ft<sup>2</sup></small><small>about the size of a tennis court</small>',
    '<small>under 5500 ft<sup>2</sup></small><small>about the size of a basketball court</small>',
    '<small>5500 to 10,000 ft<sup>2</sup></small><small>up to 1/4 acre</small>'
  ]
  const lawnExperienceOptions = [
    '<small>I\'ve never cared for a lawn before.</small>',
    '<small>I\'ve cared for a lawn, but I could use some support.</small>',
    '<small>I\'m a lawn care pro.</small>'
  ]

  const lawnRatingOptions = ['great','weeds_some','weeds_lots','bare_patches']
                            
  function addProgressBar(){
    var target = document.getElementById('progress-wrap')
    var bar = document.createElement('div')
    bar.classList.add('progress')

    target.append(bar)
    return bar
  }

  function handleZip(zip) {
    var growing_region
    // set zone info
    if(zip){
      fetchZoneInfo(zip)
        .then(data => {
          if(cfForm){
            cfForm.setFieldValue('hardiness_zone',parseInt(data.zone))
            // temporary fix for zone 8b - should be 'warm season'
            if(data.zone === "8b"){
              growing_region = 3
            } else {
              growing_region = hardinessZoneMap[parseInt(data.zone)].region
            }
            cfForm.setFieldValue('growing_region',growing_region)
          }
        })
        .catch(() => {
          console.log('Zip code error should have been caught already.');
        })
    } else {
      console.log('Oops we were not provided a zip code.');
    }
  }

  function fetchZoneInfo(zip) {
    // API that returns json from zip code
    // https://github.com/waldoj/frostline
    // alternative: https://c0bra.api.stdlib.com/zipcode-to-hardiness-zone/?zipcode=64108
    // return format is `{"zone": "8b", "temperature_range": "15 to 20", "coordinates": {"lat": "32.029022", "lon": "-102.08618"}}`
    return fetch('https://phzmapi.org/' + zip + '.json')
      .then(function (response) {
        if (response.status === 404) {
          alert('Sorry, we could not find zip code [' + zip + '] in our database')
          throw Error('Zip code [' + zip + '] not found in hardiness zone database.')
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response.json();
      })
      .catch(function (error) {
        console.log('Looks like there was a problem: \n', error);
      });
  }

  // start at 5% quiz completion, then take a big jump on second step */
  function generateStepPercents(numSteps) {
    const step_1 = 5  
    const step_2 = 35;
    const step_last = 95;
    const numStepsToCalc = numSteps - 2
    const step = (step_last - step_2) / numStepsToCalc;
    const array = [step_1, step_2];
    for (let i = 1; i <= numStepsToCalc; i++) {
        array.push(step_2 + i * step);
    }
    return array;
  }

  function setCartAttributes(attributes) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes
      })
    })
    .then(response => response.json())
    .then(cart => console.log('Cart updated:', cart))
    .catch(error => console.error('Error:', error));
  }

  /********* INIT ***********/
  function init() {
    var incomingParams = new URL(document.location.href).searchParams
    var lawnSizeParamValue = incomingParams.get('lawn_size')
    var lawnRatingParamValue = incomingParams.get('lawn_rating') ? incomingParams.get('lawn_rating').split(',') : null
    var zipParamValue = incomingParams.get('default_address.zip')
    var lawnCalcURL = new URL('https://getlawnbright.com/pages/lawn-size-calculator')
    
    CF.ready(function() {
      cfFormEl = document.querySelector('form[data-cf-form]')
      cfForm = cfFormEl.cfForm
      var progressBar = addProgressBar()
      const numSteps = cfForm.formInstance.steps.length
      const STEPS_PERCENT_ARR = generateStepPercents(numSteps)
      progressBar.style.setProperty('--percent-complete', `${STEPS_PERCENT_ARR[0]}%`)

      // listen for step changes
      document.addEventListener('cf:step_changed', function(event) {
        var to = event.detail.toIndex
        progressBar.dataset.step = to

        progressBar.style.setProperty('--percent-complete', `${STEPS_PERCENT_ARR[to]}%`)
   
        if(to === 1){
          lawnCalcURL.searchParams.append('lawn_rating',cfForm.getFieldValue('lawn_rating').join(','))
          // pre-select lawn size if we have from url
          if(lawnSizeParamValue){
            switch (lawnSizeParamValue.toLowerCase()) {
              case 'small' :
                var passedLawnSize = 2500;
                break;
              case 'medium' :
                var passedLawnSize = 5000;
                break;
              case 'large' :
                var passedLawnSize = 7500;
                break;
              default:
                var passedLawnSize = null;
                break;
            }
            if(passedLawnSize) {
              document.querySelector('.cf-step-title').innerText = 'Confirm your lawn size.'
              document.querySelector('legend.cf-screen-reader-only').innerText = 'Confirm your lawn size.'
              cfForm.setFieldValue('lawn_size', passedLawnSize)
            }
          }
          // get the link to our calc popup
          const modalLink = document.getElementById('link-to-calc')
          const modal = document.getElementById(modalLink.getAttribute('href').slice(1));
          // TODO if there's no matching modal, remove the link
          if(modalLink && modal) {
            // add aria attribute for accessibility
            modalLink.setAttribute('aria-haspopup', 'dialog');
            modalLink.addEventListener('click', (event) => {
              event.preventDefault();
              modal.show(modalLink);
            });

            modal.addEventListener('click', (event) => {
              let targetEl = event.target.closest('.exit-lawn-calc')
              if(targetEl) {
                zipParamValue = targetEl.dataset.zip
                passedLawnSize = targetEl.dataset.size
                cfForm.setFieldValue('lawn_size', parseInt(passedLawnSize))
              }
            })
          }

          
          // supplement lawn size labels and experience labels
          // (Customer Fields only allows a simple string as the label)
          // setTimeouts used here to wait for form elements to be ready
          setTimeout(function(){
            var sizeLabelEls = document.querySelectorAll('.lawn-size-options label')
            if(sizeLabelEls.length > 0) {
              sizeLabelEls.forEach((label, index) => {
                var newEl = document.createElement('div');
                newEl.innerHTML = lawnSizeOptions[index];
                label.append(newEl);
              })
            }
            var experienceLabelEls = document.querySelectorAll('.lawn-experience-options label')
            if(experienceLabelEls.length > 0) {
              experienceLabelEls.forEach((label, index) => {
                var newEl = document.createElement('div');
                newEl.innerHTML = lawnExperienceOptions[index];
                label.append(newEl);
              })
            }
          }, 50)
        }
        if(to === 2){
          var zipInput = document.querySelector('.js-zip-field input')
          zipInput.setAttribute('autocomplete', 'off') /* more harm than good for short input */
          zipInput.setAttribute('inputmode', 'numeric') /* bring up number keyboard */
          zipInput.setAttribute('pattern', '[0-9]*')
          zipInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' ) {
              zipInput.blur() /* blur field to dismiss keyboard when Enter is tapped */
            }
          })
          if(zipParamValue && /^\d{5}(-\d{4})?$/.test(zipParamValue)) {
            cfForm.setFieldValue('default_address.zip', zipParamValue)
          }
        }
        if(to === 3){
          var zip = cfForm.getFieldValue('default_address.zip');
          handleZip(zip);
        }
        // last step, record in local storage and set as Shopify cart attribute(s)
        if(to === numSteps - 1) {
          let quiz_data = {}
          const FIELDS_TO_SAVE = [
            'lawn_rating', 'lawn_size', 'default_address.zip', 'hardiness_zone', 'growing_region', 'default_address.province', 'pet_use'
          ]
          FIELDS_TO_SAVE.forEach((field) => {
            quiz_data[field] = cfForm.getFieldValue(field)
          })
          localStorage.setItem('lb_quiz_data', JSON.stringify(quiz_data))
          // For now just add the one cart attribute -- used later in upsells
          setCartAttributes({ lawn_rating: quiz_data.lawn_rating.join(", ") })
        }
      });
      
      // lawn rating is first question (step 0), cf:step_changed doesn't fire
      // if we have a lawn rating and it's one of the acceptable options
      // could be a comma-separated list
      // @link https://www.30secondsofcode.org/js/s/includes-all
      const includesAll = (arr, values) => values.every(v => arr.includes(v));
      if(lawnRatingParamValue && includesAll(lawnRatingOptions, lawnRatingParamValue)){
        cfForm.setFieldValue('lawn_rating', lawnRatingParamValue)
        cfForm.goToNextStep()
      }

      // listen for submit event and publish to Shopify
      document.addEventListener('cf:form_submitted', function(event) {
        console.log(`Submitted form ${event.detail.formId}`)
        Shopify.analytics.publish('lawnbright:quiz_submit', { email: cfForm.getFieldValue('email_address__nonshopify') });
      })
           
   }) // end Cf.ready

  } // end init

  init();
  
})();